export const validateEmail = (email) => {
	const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email.toLowerCase())
}

export const checkError = (key, object) => {
	const { errors } = object
	const length = Object.keys(errors).length

	if (length && errors[key]) {
		return Array.isArray(errors[key]) ? errors[key][0] : errors[key]
	}

	return null
}

export const errorMessage = {
	required: (key) => `${key} is required.`,
	invalidEmail: 'Invalid Email Address'
}

export const readFileData = (value) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(value)
		reader.onload = () => resolve(reader.result)
		reader.onerror = error => reject(error)
	})
}

export const formatTime = (value) => {
	let sec = Math.floor(value)
	let min = Math.floor(sec / 60)
	min = min >= 10 ? min : '0' + min
	sec = Math.floor(sec % 60)
	sec = sec >= 10 ? sec : '0' + sec
	return `${min}:${sec}`
}

export const setQueryParams = (filter) => {
	let query = `?page=${filter.page}`

	Object.keys(filter).forEach(key => {
		if (Array.isArray(filter[key]) && filter[key].length) {
			query += `&${key}=${filter[key].join('|')}`
		} else {
			key !== 'page' && filter[key] && (query += `&${key}=${filter[key]}`)
		}
	})

	return query
}

export const validMusicFormat = ['mp3', '.wav', 'aac']

export const rawMusicPlayer = {
	sound: null,
	time: 0,
	duration: 0,
	progress: 0,
	hasAudio: false,
	fileName: null
}
